var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1137 20.0002C28.3689 20.0002 30.197 18.172 30.197 15.9168C30.197 13.6617 28.3689 11.8335 26.1137 11.8335C23.8585 11.8335 22.0304 13.6617 22.0304 15.9168C22.0304 18.172 23.8585 20.0002 26.1137 20.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8704 23.3718C29.4154 22.9052 28.6804 22.9052 28.2254 23.3718L25.2737 26.3235C24.8304 26.7668 24.247 27.0118 23.6287 27.0118H19.7204C19.0787 27.0118 18.5537 26.4868 18.5537 25.8452C18.5537 25.2035 19.0787 24.6785 19.7204 24.6785H22.0537C22.6954 24.6785 23.2204 24.1535 23.2204 23.5118C23.2204 22.8702 22.6954 22.3452 22.0537 22.3452H17.387C16.1037 22.3452 15.0537 23.3952 15.0537 24.6785H12.7204C12.0787 24.6785 11.5537 25.2035 11.5537 25.8452V28.1785C11.5537 28.8202 12.0787 29.3452 12.7204 29.3452H23.6287C24.877 29.3452 26.0437 28.8552 26.9304 27.9802L29.882 25.0285C30.337 24.5735 30.337 23.8385 29.882 23.3835L29.8704 23.3718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanPayment);
export default __webpack_public_path__ + "static/media/loan_payment.37a36c5295ce85776b606d58e677924e.svg";
export { ForwardRef as ReactComponent };